import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { UserEmailService } from '@shared/services/user-email.service';
import { CxAlertsService } from '@app/libs/components/cx-alerts/cx-alerts.service';

@Component({
  selector: 'app-modal-update-email',
  templateUrl: './modal-update-email.component.html',
  styleUrls: ['./modal-update-email.component.scss']
})
export class ModalUpdateEmailComponent {
  @Input() display: boolean = false;
  @Output() displayChange = new EventEmitter<boolean>();
  
  emailForm: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private userEmailService: UserEmailService,
    private alertService: CxAlertsService
  ) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, this.emailValidator()]]
    });

    this.emailForm.get('email')?.valueChanges.subscribe(() => {
      const ctrl = this.emailForm.get('email');
      if (ctrl?.errors?.['serverError']) {
        const { serverError, ...rest } = ctrl.errors;
        ctrl.setErrors(Object.keys(rest).length ? rest : null);
      }
    });
  }

  private emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      const valid = emailRegex.test(control.value);
      return valid ? null : { email: true };
    };
  }

  closeModal(): void {
    this.display = false;
    this.displayChange.emit(this.display);
    this.emailForm.reset();
  }

  submitEmail(): void {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      this.alertService.openAlertWarn('Por favor, ingrese un correo electrónico válido');
      return;
    }

    this.loading = true;
    const email = this.emailForm.get('email')?.value;

    this.userEmailService.updateUserEmail(email).subscribe(
      (response) => {
        this.loading = false;
        this.alertService.openAlertSuccess('Correo electrónico actualizado correctamente');
        this.closeModal();
      },
      (error) => {
        this.loading = false;
        const errorMessage = error?.error?.message || 'Ocurrió un error al actualizar el correo electrónico';
        this.emailForm.get('email')?.setErrors({ serverError: errorMessage });
      }
    );
  }
}
